export const locations = {
  stripCountrySuffix: (location: string): string => {
    if (!location) return location;
    return location.replace(/, USA$/, "");
  },
};
